export default __webpack_public_path__ + "static/media/secondary-mobile.cef29748.jpg";